var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.pillClass},[_c('img',{staticClass:"homework-status-pill__icon",attrs:{"src":_vm.pillIconSource,"alt":"","aria-hidden":"true"}}),_c('span',{staticClass:"homework-status-pill__description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }